import EvOverviewContainer from '@apps/containers/EvOverviewContainer';
import Stack from '@mui/material/Stack';
import { TitleDivider } from '@stack/ui';

import { Props } from './props';

export const EvOverviewScreen: React.FC<Props> = ({ evOverview, webView }) => {
  const title = 'EV Overview';

  return (
    <>
      <TitleDivider
        title={webView ? '' : title}
        webView={webView}
        titleVariant="h1"
      ></TitleDivider>
      <Stack
        sx={{
          marginTop: { xs: webView ? 0 : 5.5, md: 0, mt: webView ? -4.5 : 0 },
        }}
      >
        <EvOverviewContainer evOverview={evOverview} webView={webView} />
      </Stack>
    </>
  );
};

export default EvOverviewScreen;
